/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import { Button } from 'devextreme-react/autocomplete';
import {
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { addModuloID } from '~/store/modules/Modulos/actions';
import { gridModuloDataSource } from '../../ModulosServices';
import { Container } from './styles';

function Lista({ loading }) {
  const history = useHistory();
  const disptach = useDispatch();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }
    setPageIndex(null);
  }

  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  return (
    <Container>
      <section>
        <div className="sec1">
          <h1>Módulos</h1>
        </div>
        <div className="add">
          <Link to="/modulo/register" className="link">
            <FaPlus />
          </Link>
        </div>
      </section>
      {loading ? (
        <Spinner
          color="dark"
          style={{ height: '3rem', width: '3rem', marginLeft: ' 350px' }}
        />
      ) : (
        <DataGrid
          dataSource={gridModuloDataSource}
          remoteOperations
          showBorders
          allowColumnReordering
          allowColumnResizing
          columnAutoWidth
          onOptionChanged={handleOptionChange}
        >
          <Editing mode="row" useIcons allowDeleting />
          <Pager
            visible
            showPageSizeSelector
            allowedPageSizes={[7, 10, 15]}
            showInfo
          />
          <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
          <FilterRow
            visible={filterOptions.showFilterRow}
            applyFilter={filterOptions.currentFilter}
          />
          <Column
            dataField="id"
            caption="ID do Módulo"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="nome"
            caption="Nome grupo"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column type="buttons" caption="Menus" width={100}>
            <Button
              hint="Menus"
              visible
              icon="menu"
              onClick={(e) => {
                disptach(addModuloID(e.row.data.id));
                history.push(`/modulo/menu/${e.row.data.id}`);
              }}
            />
          </Column>
          <Column type="buttons" caption="Página" width={100}>
            <Button
              hint="Editar"
              visible
              icon="file"
              onClick={(e) => {
                disptach(addModuloID(e.row.data.id));
                history.push(`/modulo/page/${e.row.data.id}`);
              }}
            />
          </Column>
          <Column type="buttons" caption="Ações" width={100}>
            <Button
              hint="Editar"
              visible
              icon="edit"
              onClick={(e) => history.push(`/modulo/update/${e.row.data.id}`)}
            />
            <Button name="delete" visible hint="Deletar" icon="trash" />
          </Column>
        </DataGrid>
      )}
    </Container>
  );
}

export default Lista;
